var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.onClick}},[_c('EditableSectionText',{attrs:{"element":"span","section":_vm.section,"property":"menuTitle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }